import { createElement } from 'react';
import { cn } from '@/lib/utils';

type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

const headingStyles: Record<HeadingLevel, string> = {
  h1: 'text-4xl font-bold text-foreground',
  h2: 'text-3xl font-bold text-foreground',
  h3: 'text-2xl font-semibold text-foreground',
  h4: 'text-xl font-semibold text-foreground',
  h5: 'text-lg font-medium text-foreground',
  h6: 'text-base font-medium text-foreground',
};

export interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  level?: HeadingLevel;
}

export function Heading({ level = 'h2', className, ...props }: HeadingProps) {
  return createElement(level, {
    className: cn(headingStyles[level], className),
    ...props,
  });
}
